import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const ReseauxSociaux = () => {
  return (
    <>
      <Helmet>
        <title>Gestion Réseaux Sociaux - ZiExter | Community Management & Modération</title>
        <meta name="description" content="Externalisez la modération et la gestion de vos réseaux sociaux. Réponses aux messages, modération de commentaires, community management 24/7." />
        <link rel="canonical" href="https://ziexter.com/services/reseaux-sociaux" />
      </Helmet>

      <section className="page-hero bg-gradient-to-br from-secondary to-primary text-white">
        <div className="container-custom">
          <div className="max-w-3xl animate-fade-in-up">
            <nav className="flex items-center space-x-2 text-sm mb-4 text-gray-200">
              <Link to="/" className="hover:text-white">Accueil</Link>
              <span>/</span>
              <Link to="/services" className="hover:text-white">Services</Link>
              <span>/</span>
              <span className="text-white">Réseaux Sociaux</span>
            </nav>
            <h1 className="font-heading text-4xl md:text-5xl font-bold mb-6">
              Gestion des Réseaux Sociaux – ZiExter
            </h1>
            <p className="text-xl text-gray-100 mb-4">
              Externalisez la modération et la gestion de vos réseaux sociaux
            </p>
            <p className="text-lg text-gray-200">
              De la modération des commentaires au community management complet, ZiExter assure une présence active et professionnelle sur vos réseaux sociaux, 24h/24 et 7j/7.
            </p>
          </div>
        </div>
      </section>

      <section className="py-8 bg-accent">
        <div className="container-custom">
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/devis" className="btn btn-secondary">Découvrez nos solutions</Link>
            <Link to="/contact" className="btn btn-outline-white">Planifiez un échange avec un expert</Link>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto animate-fade-in-up">
            <h2 className="section-title text-center mb-8">Vos réseaux sociaux : une vitrine… ou un champ de mines ?</h2>
            <p className="text-lg text-gray-700 mb-4">
              Facebook, Instagram, LinkedIn, TikTok… Vos clients y sont. Mais entre commentaires négatifs, messages privés non répondus, avis clients et spam, la gestion quotidienne devient chronophage.
            </p>
            <p className="text-lg font-semibold text-primary">
              Avec ZiExter, confiez la gestion de vos réseaux sociaux à des experts. Nous modérons, répondons, animons et protégeons votre e-réputation pendant que vous vous concentrez sur votre cœur de métier.
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Nos services de gestion des réseaux sociaux</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              { title: 'Modération de commentaires', desc: 'Nous surveillons et modérons vos commentaires en temps réel. Suppression des spams, gestion des trolls, validation des messages.' },
              { title: 'Réponse aux messages privés', desc: 'Traitement des demandes clients en MP (Facebook Messenger, Instagram DM, LinkedIn Messages).' },
              { title: 'Gestion des avis clients', desc: 'Réponses professionnelles aux avis Google, Facebook, Trustpilot… positifs comme négatifs.' },
              { title: 'Community Management', desc: 'Animation de votre communauté : réponses engageantes, interactions, gestion de la relation client sur les réseaux.' },
              { title: 'Veille e-réputation', desc: 'Surveillance de votre image en ligne et alertes en cas de crise ou commentaire sensible.' },
              { title: 'Reporting détaillé', desc: 'Rapports hebdomadaires : nombre de messages traités, temps de réponse moyen, analyse des tendances.' }
            ].map((item, i) => (
              <div key={i} className="card hover-lift animate-fade-in-up" style={{ animationDelay: `${i * 50}ms` }}>
                <h3 className="font-bold mb-2">{item.title}</h3>
                <p className="text-sm text-gray-700">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Ils nous font confiance pour leurs réseaux sociaux</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { title: 'E-commerce mode, France', problem: 'Commentaires non modérés, image dégradée.', solution: 'Modération 24/7 et réponses personnalisées aux avis clients.', result: 'Taux d\'engagement +35%, e-réputation restaurée.' },
              { title: 'Chaîne hôtelière, Europe', problem: 'Messages privés non traités, clients insatisfaits.', solution: 'Gestion multilingue des MP et avis en 5 langues.', result: 'Temps de réponse divisé par 3, satisfaction client +40%.' },
              { title: 'SaaS B2B, Belgique', problem: 'Faible interaction sur LinkedIn, leads perdus.', solution: 'Community management actif et qualification de prospects.', result: '+50% d\'interactions qualifiées, +20 leads/mois.' }
            ].map((item, i) => (
              <div key={i} className="card hover-lift animate-fade-in-up" style={{ animationDelay: `${i * 100}ms` }}>
                <h3 className="font-bold mb-3">{item.title}</h3>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li><strong>Problème :</strong> {item.problem}</li>
                  <li><strong>Solution ZiExter :</strong> {item.solution}</li>
                  <li><strong>Résultat :</strong> {item.result}</li>
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Performance garantie</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: '💬', stat: '10 000', label: 'messages traités par mois' },
              { icon: '⏱️', stat: '< 1h', label: 'Temps moyen de réponse' },
              { icon: '🌍', stat: '8 langues', label: 'Modération multilingue' },
              { icon: '⭐', stat: '96%', label: 'Satisfaction utilisateurs' }
            ].map((item, i) => (
              <div key={i} className="card text-center hover-lift animate-fade-in-up" style={{ animationDelay: `${i * 50}ms` }}>
                <div className="text-3xl mb-2">{item.icon}</div>
                <div className="text-2xl font-bold text-primary mb-1">{item.stat}</div>
                <p className="text-sm text-gray-600">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">Avis Clients</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { quote: 'ZiExter a sauvé notre image en ligne. Réactivité exemplaire sur tous nos réseaux sociaux.', name: 'Clara Moreau', role: 'Responsable marketing, E-commerce' },
              { quote: 'Nos clients apprécient la rapidité des réponses, même le week-end. Un vrai atout pour notre groupe.', name: 'Jean-Marc Petit', role: 'Directeur, Chaîne hôtelière' },
              { quote: 'L\'équipe ZiExter comprend notre ADN et interagit avec notre communauté comme si elle en faisait partie.', name: 'Sophie Renard', role: 'CEO, SaaS B2B' }
            ].map((item, i) => (
              <div key={i} className="card hover-lift animate-fade-in-up" style={{ animationDelay: `${i * 100}ms` }}>
                <p className="text-gray-700 mb-4 italic">"{item.quote}"</p>
                <div className="font-semibold">{item.name}</div>
                <div className="text-sm text-gray-600">{item.role}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-12 animate-fade-in-up">
            <h2 className="section-title">FAQ</h2>
          </div>
          <div className="max-w-4xl mx-auto space-y-4">
            {[
              { q: 'Quels réseaux sociaux gérez-vous ?', a: 'Facebook, Instagram, LinkedIn, Twitter/X, TikTok, YouTube, Google My Business, Trustpilot et autres.' },
              { q: 'Répondez-vous au nom de mon entreprise ?', a: 'Oui, nos community managers utilisent votre identité de marque et suivent vos guidelines.' },
              { q: 'Puis-je valider les réponses avant publication ?', a: 'Oui, nous pouvons mettre en place un processus de validation pour les messages sensibles.' },
              { q: 'Que faites-vous en cas de crise (bad buzz) ?', a: 'Nous vous alertons immédiatement et appliquons votre plan de gestion de crise ou nos bonnes pratiques.' },
              { q: 'Puis-je commencer par un réseau social puis ajouter d\'autres ?', a: 'Absolument. Nous adaptons notre offre à vos besoins et évolutions.' }
            ].map((item, i) => (
              <details key={i} className="card cursor-pointer">
                <summary className="font-semibold p-4 flex justify-between items-center">
                  <span>Q : {item.q}</span>
                  <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </summary>
                <div className="p-4 pt-0 text-gray-600">{item.a}</div>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="section-padding bg-gradient-to-r from-primary to-secondary text-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center animate-fade-in-up">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-6">
              Boostez votre présence en ligne avec ZiExter
            </h2>
            <p className="text-xl text-gray-100 mb-8">
              Confiez-nous vos réseaux sociaux et concentrez-vous sur votre activité. Nous gérons tout : modération, réponses, animation et reporting.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="btn btn-accent btn-lg">Contactez notre équipe Social Media</Link>
              <Link to="/devis" className="btn btn-outline-white btn-lg">Demandez un devis personnalisé</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ReseauxSociaux;
